import React, { useState, useEffect } from 'react'
import { Box, FormControl, FormLabel, Input, Button, Flex, Text, Badge, Collapse, useDisclosure, IconButton, Tooltip } from '@chakra-ui/react'
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons'
import { format } from 'date-fns'

export const DateSimulator = ({ isAdminUser, updateSimulatedDate, isSimulated, simulatedDate, resetSimulation }) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: false })
  const [dateValue, setDateValue] = useState('')
  const [timeValue, setTimeValue] = useState('')

  // Se não for admin, não mostrar nada

  // Define valores iniciais quando uma data simulada é definida
  useEffect(() => {
    if (simulatedDate && isSimulated) {
      try {
        setDateValue(format(simulatedDate, 'yyyy-MM-dd'))
        setTimeValue(format(simulatedDate, 'HH:mm'))
      } catch (error) {
        console.error('Erro ao formatar data simulada:', error)
      }
    }
  }, [simulatedDate, isSimulated])

  const handleSubmit = (e) => {
    e.preventDefault()
    if (dateValue) {
      updateSimulatedDate(dateValue, timeValue || '00:00')
    }
  }

  const handleReset = () => {
    setDateValue('')
    setTimeValue('')
    resetSimulation()
  }

  if (!isAdminUser) return null

  return (
    <Box mb={4} bg="#f0fff4" p={2} borderRadius="md" border="1px solid #37F091">
      <Flex justifyContent="space-between" alignItems="center" onClick={onToggle} cursor="pointer" mb={2}>
        <Text fontWeight="bold" color="green.600" fontSize="sm">
          Modo Simulação
          {isSimulated && (
            <Badge ml={2} colorScheme="green">
              ATIVO
            </Badge>
          )}
        </Text>
        <IconButton
          size="xs"
          aria-label="Expandir/Recolher"
          icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          variant="ghost"
          color="green.500"
        />
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <Box>
          <form onSubmit={handleSubmit}>
            <Flex direction={{ base: 'column', md: 'row' }} gap={2} mb={2}>
              <FormControl>
                <FormLabel htmlFor="date-input" fontSize="xs" mb={1}>
                  Data
                </FormLabel>
                <Input id="date-input" size="sm" type="date" value={dateValue} onChange={(e) => setDateValue(e.target.value)} required />
              </FormControl>

              <FormControl>
                <FormLabel htmlFor="time-input" fontSize="xs" mb={1}>
                  Hora
                </FormLabel>
                <Input id="time-input" size="sm" type="time" value={timeValue} onChange={(e) => setTimeValue(e.target.value)} />
              </FormControl>
            </Flex>

            <Flex justifyContent="space-between">
              <Tooltip label="Simular calendário com esta data e hora">
                <Button size="sm" colorScheme="green" type="submit">
                  Simular
                </Button>
              </Tooltip>
              <Tooltip label="Voltar para a data atual">
                <Button size="sm" variant="outline" colorScheme="red" onClick={handleReset}>
                  Resetar
                </Button>
              </Tooltip>
            </Flex>
          </form>

          {isSimulated && (
            <Text fontSize="xs" mt={2} color="green.600">
              Simulando: {format(simulatedDate, 'dd/MM/yyyy HH:mm')}
            </Text>
          )}
        </Box>
      </Collapse>
    </Box>
  )
}
